import {twMerge} from 'tailwind-merge';
import {type ClassValue, clsx} from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const groupBy = <G, K extends keyof G>(items: G[], field: K) => {
  return items.reduce<Record<string, G[]>>((a, b) => {
    const key = String(b[field]);
    if (!a[key]) a[key] = [];
    a[key].push(b);

    return a;
  }, {});
};
